import { useEffect } from "react";
import { Hero } from "@/components/home/Hero";
import { About } from "@/components/home/About";
import { Directions } from "@/components/home/Directions";
import { Clients } from "@/components/home/Clients";
import { Cases } from "@/components/home/Cases";
import { Why } from "@/components/home/Why";
import { Marquee } from "@/components/Marquee";
import { Stages } from "@/components/Stages";
import { Contact } from "@/components/Contact";
import { useSite } from "@/lib/site";

export default function Home() {
  const { t, content } = useSite();
  useEffect(() => { document.title = "Dari Event — Event · Production · Marketing · Booking"; }, []);
  const marquee = (Array.isArray(content?.marquee) ? content.marquee : []).map(t);
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee items={marquee} testId="home-marquee" />
      <About />
      <Directions />
      <Clients />
      <Cases />
      <Why />
      <Stages />
      <Contact />
    </main>
  );
}
